import { Plugin } from 'hubspot-prosemirror/pm/state';
import Raven from 'raven-js';
import { addTemporaryImageNodes, isImageFile } from '../utils/imageUtils';

export function createImagePastePlugin({
  fileManagerAccess,
  folderPath,
  defaultImageWidth,
}: {
  fileManagerAccess?: string;
  folderPath?: string;
  defaultImageWidth?: number;
}) {
  const ImagePastePlugin = new Plugin({
    props: {
      handlePaste: (view, event) => {
        if (event.clipboardData) {
          const files = event.clipboardData.files;
          if (files.length && !event.clipboardData.getData('text')) {
            const file = files.item(0);
            if (file && isImageFile(file)) {
              void addTemporaryImageNodes(view.state, view.dispatch, [file], {
                fileManagerAccess,
                folderPath,
                defaultImageWidth,
              }).catch((e) => {
                Raven.captureException(e);
              });
              return true;
            }
          }
        }
        return false;
      },
    },
  });
  return ImagePastePlugin;
}
